import React from "react";
import PropTypes from "prop-types";
import PhysicianUtils from "services/PhysicianUtils";
import CalendarUtils from "services/CalendarUtils";
import ListBadge from "components/Common/ListBadge";
import AppointmentUtils from "services/AppointmentUtils";
import PatientUtils from "services/PatientUtils";
import useFetchPatients from "hooks/useFetchPatients";
import { useAppSelector } from "careand-redux/store";

const dateFormat = "YYYY/MM/DD h:mm A";

const AppointmentBadge = ({
  appointment = {},
  showPatientName,
}) => {
  useFetchPatients([appointment]);

  const physicians = useAppSelector((state) => state.physicians.byId);
  const patients = useAppSelector((state) => state.patients.byId);

  return (
    <ListBadge
      title={
        showPatientName
          ? getPatientName(patients[appointment.patient_id]) || ""
          : getPhysicianName(physicians[appointment.physician_id]) || ""
      }
      firstLine={AppointmentUtils.getAppointmentDescription(appointment, true)}
      secondLine={getDate(appointment)}
      className="appointment-badge"
      id={`appointment-badge-${appointment.id}`}
    />
  );
};

function getPhysicianName(physician) {
  return PhysicianUtils.getNameWithSpecialty(physician);
}

function getPatientName(patient) {
  return PatientUtils.getName(patient, undefined, false);
}

function getDate(appointment) {
  return CalendarUtils.format(appointment.date, dateFormat);
}

AppointmentBadge.propTypes = {
  appointment: PropTypes.object.isRequired,
  showPatientName: PropTypes.bool,
};

AppointmentBadge.defaultProps = {
  showPatientName: false,
};

export default AppointmentBadge;
